"use client";

import { useState } from "react";
import { Form, Input, Button, message } from "antd";

export default function AccountSecurity() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handlePasswordChange = async (values) => {
    setLoading(true);
    try {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000));

      if (values.newPassword !== values.confirmPassword) {
        message.error("New passwords do not match!");
        return;
      }

      message.success("Password updated successfully!");
      form.resetFields(["currentPassword", "newPassword", "confirmPassword"]);
    } catch (error) {
      message.error("Failed to update password");
    } finally {
      setLoading(false);
    }
  };

  const handleLogoutAllDevices = async () => {
    setLoading(true);
    try {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000));
      message.success("Logged out from all other devices");
    } catch (error) {
      message.error("Failed to logout from other devices");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-[16px] bg-white rounded-lg h-full">
      <h1 className="text-[18px] font-semibold text-[#171717] font-poppins">
        Account & Security (Managed By Admin)
      </h1>
      <p className="text-[#171717] text-[14px] font-poppins mt-2 ">
        Keep your account secure with password updates and login activity
        control.
      </p>

      <div className="border-t border-[#E2E8F0] ">
        <h2 className="text-[12px]  text-[#171717] font-poppins mb-2 mt-[12px]">
          Email ID
        </h2>
        <Input
          className="rounded-[12px] py-[16px] px-[16px] bg-[#E9E9E9] text-[#64748B] border-1 border-[#CBD5E1] text-[16px] font-poppins"
          value={localStorage.getItem("email")}
          disabled
        />
      </div>

      {/* <div className="mt-[16px]">
        <h2 className="text-[14px] font-medium text-[#1E1E1E] mb-[12px] font-poppins">
          Change Password
        </h2>
        <Form form={form} layout="vertical" onFinish={handlePasswordChange}>
          <Form.Item
            name="currentPassword"
            label={
              <span className="text-[12px]  text-[#292929] font-poppins ">
                Current Password
              </span>
            }
            rules={[
              {
                required: true,
                message: "Please input your current password!",
              },
            ]}
          >
            <Input.Password
              placeholder="Type here"
              className="rounded-[12px] py-[16px] px-[16px] bg-[#F4F9FF] font-poppins"
            />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label={
              <span className="text-[12px]  text-[#292929] font-poppins ">
                New Password
              </span>
            }
            rules={[
              { required: true, message: "Please input your new password!" },
              { min: 8, message: "Password must be at least 8 characters" },
            ]}
          >
            <Input.Password
              placeholder="Type here"
              className="rounded-[12px] py-[16px] px-[16px] bg-[#F4F9FF] font-poppins"
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label={
              <span className="text-[12px]  text-[#292929] font-poppins  ">
                Confirm Password
              </span>
            }
            rules={[
              { required: true, message: "Please confirm your password!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The two passwords do not match!")
                  );
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Type here"
              className="rounded-[12px] py-[16px] px-[16px] bg-[#F4F9FF] font-poppins"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="bg-[#0B4F9F] hover:bg-[#0B4F9F] border-none rounded-md w-[124px] h-[40px] px-8 font-medium text-[#FFFFFF] text-[14px] font-poppins"
            >
              Save
            </Button>
          </Form.Item>
        </Form>
      </div> */}

      {/* <div className="mb-8">
        <h2 className="text-[14px] font-poppins font-medium text-[#1E1E1E] mb-2">
          Device Management
        </h2>
        <div className="flex items-center justify-between">
          <span className="text-[#1E1E1E] text-[14px] font-poppins">
            Logout from all other devices
          </span>
          <Button
            onClick={handleLogoutAllDevices}
            loading={loading}
            className="border border-[#0B4F9F] text-[#0B4F9F] bg-[#F0F6FF] hover:bg-blue-50 font-poppins rounded-md px-6"
          >
            Logout
          </Button>
        </div>
      </div> */}
    </div>
  );
}
